export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_medlearn-connect/artifacts/iwnmjw12_file_00000000e00482118c3dadcc3f406758.webp";

export function Logo({ className = "h-8", chip = true }) {
  const img = (
    <img src={LOGO_URL} alt="Medlane" className={`${className} w-auto object-contain`} draggable={false} />
  );
  if (!chip) return img;
  return (
    <span className="inline-flex items-center rounded-xl bg-white px-2.5 py-1.5 shadow-sm ring-1 ring-amber-200/50">
      {img}
    </span>
  );
}
